import getSelectedFolderView from '../selectors/getSelectedFolderView';

export default function(itemId: string): boolean {
    const folderView = getSelectedFolderView();
    return folderView.activeTaskIds !== null && folderView.activeTaskIds.indexOf(itemId) > -1;
}
